import React from 'react';

const Overview = React.lazy(() => import('src/investorSystem/views/Overview/Overview'));
const Transactions = React.lazy(
  () => import('src/investorSystem/views/TransactionsView/Transactions'),
);
const DocumentCenter = React.lazy(() => import('../views/DocumentCenter/DocumentCenter'));
const MyAccount = React.lazy(() => import('../views/MyAccountView/MyAccount'));
const Offering = React.lazy(() => import('../views/Offerings/Offerings'));
const Entities = React.lazy(() => import('../views/Entities/EntitiesView'));

const DashboardRoutes = [
  { path: '/overview', name: 'overview', component: Overview, exact: true },
  { path: '/transactions', name: 'Transactions', component: Transactions, exact: true },
  { path: '/documents', name: 'documents', component: DocumentCenter },
  { path: '/my-account', name: 'My Account', component: MyAccount },
  { path: '/offerings', name: 'Offerings', component: Offering },
  { path: '/entities', name: 'Entities', component: Entities },
];

export default DashboardRoutes;
